<!--
 * @Author: Nie Wie
 * @Date: 2020-02-22 11:17:18
 * @LastEditors: Nie Wie
 * @LastEditTime: 2020-03-30 14:37:11
 * @Description: 卡片小组件
 -->
<template>
  <div class="num-card" :style="{'background-color': bgcolor }">
    <!-- <div class="num-card__added">
      <span :style="{'color':color}">{{' '}}</span>
    </div> -->
    <div class="num-card__total">
      <span :style="{'color':color}">{{total === null ? '-' : total}}</span>{{danwei}}
    </div>
    <div class="num-card__name">
      <span>{{name}}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // added: {
    //   type: [ String, Number ],
    //   default() {
    //     return '-'
    //   },
    // },
    total: {
      type: [ String, Number ],
      default() {
        return '-'
      },
    },
    danwei: {
      type: String,
      default() {
        return ''
      },
    },
    name: {
      type: String,
      default() {
        return '数据项'
      },
    },
    color: {
      type: String,
      default() {
        return 'red'
      },
    },
    bgcolor: {
      type: String,
      default() {
        return 'rgba(222,0,0,.3)'
      },
    },
  },
}
</script>

<style lang="scss">
.num-card {
  margin: 2px;
  width: 222px;
  position: relative;
  text-align: center;
  font-size: 20px;
  font-family:PingFangSC-Regular,PingFang SC;
}
.num-card__added {
  padding-top: 22px;
  color: #7c7c7c;
  line-height: 24px;
  font-weight: 500;
  span {
    margin-left: 5px;
  }
}
.num-card__total {
  height: auto;
  padding-top: 38px;
  line-height: 46px;
  margin-bottom: 0px;
  color: #7c7c7c;
  span {
    font-size: 44px;
    font-family:Helvetica-Bold,Helvetica;
    font-weight:bold;
    margin-right: 5px;
  }
}
.num-card__name {
  margin-bottom: 15px;
  height: 54px;
  line-height: 54px;
  color: #222;
  font-size:24px;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight: 500;
}
</style>
